"use strict";

class PropertyKeyHandoverController {

    constructor($timeout, SSHttpService, SSAppService, SSUtilService, SSConfigService, SSDateService, SSUserService, SSStorageService, SSAlertService, SSConfirmationService, SSKeyHandoverService) {

        const self = this;

        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSAppService = SSAppService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSDateService = SSDateService;
        self.SSUserService = SSUserService;
        self.SSStorageService = SSStorageService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSKeyHandoverService = SSKeyHandoverService;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;

        self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED;
        self.KEY_HANDOVER_APPOINTMENT_STATUS_RESCHEDULED = SHOWSUITE.KEY_HANDOVER_APPOINTMENT_STATUS_RESCHEDULED;

        self.KEY_HANDOVER_BUYER_TYPE_MAIN = SHOWSUITE.KEY_HANDOVER_BUYER_TYPE_MAIN;
        self.KEY_HANDOVER_BUYER_TYPE_NOMINEE = SHOWSUITE.KEY_HANDOVER_BUYER_TYPE_NOMINEE;

        self.KEY_HANDOVER_STATUS_READY = SHOWSUITE.KEY_HANDOVER_STATUS_READY;
        self.KEY_HANDOVER_STATUS_SCHEDULED = SHOWSUITE.KEY_HANDOVER_STATUS_SCHEDULED;
        self.KEY_HANDOVER_STATUS_COMPLETED = SHOWSUITE.KEY_HANDOVER_STATUS_COMPLETED;

        self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION = SHOWSUITE.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION;
        self.APPOINTMENT_FILE_TYPE_NRIC_FRONT = SHOWSUITE.APPOINTMENT_FILE_TYPE_NRIC_FRONT;
        self.APPOINTMENT_FILE_TYPE_NRIC_BACK = SHOWSUITE.APPOINTMENT_FILE_TYPE_NRIC_BACK;
        self.APPOINTMENT_FILE_TYPE_PASSPORT = SHOWSUITE.APPOINTMENT_FILE_TYPE_PASSPORT;
        self.APPOINTMENT_FILE_TYPE_OTHERS = SHOWSUITE.APPOINTMENT_FILE_TYPE_OTHERS;

        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.countries = self.SSConfigService.getCountries();

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        // Limit and Offset for 'buyers' search
        self.apiLimit = 10;
        self.apiOffset = 0;

        self.updateStatusParams = {};

        if(!self.SSUserService.getUser()){
            self.SSUserService.showLoginModal();
        }

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // self.SSKeyHandoverService.newAppointment = self.SSUtilService.getURLParameter('new_appointment');
        self.SSKeyHandoverService.newAppointment = self.SSUtilService.getFromLocalStorage('newAppointment');

        self.buyers = [];
        self.searchParams = {};

        self.SSKeyHandoverService.searchFilter = self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED;
        //self.SSKeyHandoverService.start_date = moment().format('DD/MM/YYYY'); // Default today's filter
        self.SSKeyHandoverService.collectionDate = moment().format('DD/MM/YYYY');

        self.SSKeyHandoverService.property = self.property;

        self.SSKeyHandoverService.limit = 10;
        self.SSKeyHandoverService.offset = 0;

        $('.collection-date').datepicker({dateFormat: "dd/mm/yy", maxDate: new Date()});

        self.$timeout(function() {
            // https://api.jqueryui.com/datepicker/#option-minDate
            $('.date-input').datepicker({dateFormat: "dd/mm/yy"});
        });

        // self.initRepDocumentTypes();
        self.initBuyerDocumentTypes();

        self.prepareAppointmentStatuses();
        self.getPropertySettings();

        if(self.SSKeyHandoverService.newAppointment)
            self.SSKeyHandoverService.setStepOneViewMode(null, 1);
    }

    hasPermissionForProperty(permission, property_id){
        const self = this;
        
        if(permission && property_id){
            return self.SSUserService.hasPermissionForProperty(permission, property_id);
        }
    }

    getPropertySettings(){
        const self = this;

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        self.SSKeyHandoverService.getPropertySettings(url, function(response){

            if(response && response.key_handover_settings){
                self.key_handover_settings = response.key_handover_settings;
                self.SSKeyHandoverService.getKeyHandoverAppointments(self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED);
            }
        });
    }

    saveAppointment(){
        const self = this;

        self.SSKeyHandoverService._saveUserAppointment();
    }

    editAppointmentDetails(editMode){
        const self = this;

        self.SSKeyHandoverService.appointmentEditMode = editMode;
        if(editMode){
            self.SSKeyHandoverService.getAllAppointments(null);
        }
        self.SSKeyHandoverService.setStepOneViewMode(self.SSKeyHandoverService.appointmentParams, 1);
    }

    prepareAppointmentStatuses(){
        const self = this;

        self.appointmentStatuses = [
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_PENDING, name: 'PENDING', _class: 'text-primary' },
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED, name: 'SCHEDULED', _class: 'text-success' },
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL, name: 'KEY COLLECTED', _class: 'text-success' },
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED, name: 'EXPIRED', _class: 'text-primary' },
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED, name: 'CANCELLED', _class: 'text-danger' },
            {id: self.KEY_HANDOVER_APPOINTMENT_STATUS_RESCHEDULED, name: 'RESCHEDULED', _class: 'text-warning' }
        ];
    }

    initBuyerDocumentTypes(){
        const self = this;

        self.buyerDocumentTypes = [
            {id: self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION, name: "Letter of authorisation"},
            {id: self.APPOINTMENT_FILE_TYPE_NRIC_FRONT, name: "NRIC Front"},
            {id: self.APPOINTMENT_FILE_TYPE_NRIC_BACK, name: "NRIC Back"},
            {id: self.APPOINTMENT_FILE_TYPE_PASSPORT, name: "Passport"},
            {id: self.APPOINTMENT_FILE_TYPE_OTHERS, name: "Other Letter"}
        ];
    }

    downloadAppointments(downloadAppType){
        const self = this;

        self.date_from = null;
        self.date_to = null;
        self.selected_status = null;
        self.downloadAppType = downloadAppType;
        $(".date-input").datepicker("option", "dateFormat", "dd/mm/yy");

        $('#keyhandoverAppointmentsDownloadModal').modal('show');
    }

    exportAppointments(){
        const self = this;

        /** WEB-2933 Key handover Search Issue
         * Update Download Appointments URL to reports server
         let url = "sec/developer/key-handover/appointments/download?property_id="+ self.property.id; **/
        // WEB-3591: the '2' variant must be chosen BEFORE the URL is built --
        // getReportURL() returns a URL that already ends in a query separator,
        // so appending to it would put the '2' in the query, not the path.
        let reportPath = "api/reports/key-handover-appointments-min";
        if(self.downloadAppType === 2){
            reportPath = reportPath + '2';
        }
        let url = self.SSHttpService.getReportURL(reportPath);

        if(self.property.id) url = url + "&property_id=" + self.property.id;
        if(self.date_from) url = url + "&start_date=" + self.SSUtilService.formatDateToStore(self.date_from);
        if(self.date_to) url = url + "&end_date=" + self.SSUtilService.formatDateToStore(self.date_to);
        if(self.selected_status) url = url + "&status=" + self.selected_status;

        try{
            // exception may occur for cross browsers.
            url = url +"&timezone="+ Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        catch(ex){
            console.log(ex);
        }

        /** WEB-2933 Key handover Search Issue
         * Update Download Appointments URL to reports server
         window.open(self.SSHttpService.getApiURL(url), '_blank'); **/
        window.open(url, '_blank');
    }

    viewBuyers(buyers){
        const self = this;

        self.buyerIndex = 0;
        self.buyerModalData = buyers;

        self.showBuyer = true;
        $('#agentSaleApplicationBuyerModal').modal('show');
    }

    getPreviousBuyer(){
        const self = this;

        if(self.buyerIndex > 0){
            let index = self.buyerIndex - 1;
            self.buyerIndex = index;
        }
    }

    getNextBuyer(){
        const self = this;

        if(self.buyerIndex < self.buyerModalData.length - 1){
            let index = self.buyerIndex + 1;
            self.buyerIndex = index;
        }
    }

    checkIfResent(appointment){
        const self = this;

        if(!appointment) return;

        if(appointment.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_EXPIRED 
            || appointment.status == self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED){
            if(appointment.unit && appointment.unit.key_handover_status == self.KEY_HANDOVER_STATUS_READY){
                return ' - Resent';
            }
        }
    }

    hideModal() {
        const self = this;

        self.showChooseBuyerModal = false;
        if ($('#chooseBuyerModal').is(':visible')) $('#chooseBuyerModal').modal('hide');
        if ($('#keyUpdateStatusModal').is(':visible')) $('#keyUpdateStatusModal').modal('hide');

    }
    
    updateStatus(appointment, status) {
        const self = this;

        if (!appointment || !status) {
            return;
        }

        self.updateStatusAppointment = angular.copy(appointment);
        self.SSKeyHandoverService.collectionDate = moment().format('DD/MM/YYYY');

        self.updateStatusParams = {
            status: status,
            property_id: self.property_id,
            resend: null,
            collection_date: null,
        };

        if (status == self.KEY_HANDOVER_APPOINTMENT_STATUS_SUCCESSFUL) {
            self.hideModal();

            $('#keyUpdateStatusModal').modal('show');

        } else {
            let confirmationMessage = null;
            if (status == self.KEY_HANDOVER_APPOINTMENT_STATUS_CANCELED) {
                self.updateStatusParams.resend = 1;
                confirmationMessage = 'Are you sure you want to cancel this appointment? If you proceed, this appointment will be canceled and the unit will be available for purchaser to re-schedule the appointment.';
            } else if (status == self.KEY_HANDOVER_APPOINTMENT_STATUS_SCHEDULED) {
                confirmationMessage = 'Are you sure you want to approve this appointment? If you proceed, this appointment will be approved and placed under Scheduled section.';
            } else if (status == self.KEY_HANDOVER_APPOINTMENT_STATUS_RESCHEDULED) {
                confirmationMessage = 'Are you sure you want to reset this appointment? If you proceed, the unit will be available for purchaser to re-schedule the appointment.';
            }
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                confirmationMessage,
                self.SSConfirmationService.TYPE_DEFAULT, function () {
                    let url = 'sec/developer/key-handover/appointments/' + appointment.id + '/update-status';
                    loading(true);
                    self.SSHttpService.putAPIRequest(url, self.updateStatusParams).then(function (response) {
                        loading(false);

                        if (response instanceof Error) {
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        if (response.success) {
                            self.SSAlertService.success('Appointment updated successfully.');
                            self.hideModal();

                            self.SSKeyHandoverService.getKeyHandoverAppointments(self.SSKeyHandoverService.searchFilter);
                        }
                    });
                });
        }
    }

    _updateStatus(){
        const self = this;

        let url = 'sec/developer/key-handover/appointments/'+ self.updateStatusAppointment.id +'/update-status';
        
        // let params = {
        //     status: status,
        //     property_id: self.property.id
        // };

        let collectionDate = moment(self.SSKeyHandoverService.collectionDate, 'DD/MM/YYYY');
        self.updateStatusParams['collection_date'] = collectionDate.format('YYYY-MM-DD 12:00:00');

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.updateStatusParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.success){
                self.SSAlertService.success('Appointment updated successfully.');
                self.hideModal();
                
                self.SSKeyHandoverService.getKeyHandoverAppointments(self.SSKeyHandoverService.searchFilter);
            }
        });
    }
}

PropertyKeyHandoverController.$inject = ['$timeout', 'SSHttpService', 'SSAppService', 'SSUtilService', 'SSConfigService', 'SSDateService', 'SSUserService', 'SSStorageService', 'SSAlertService', 'SSConfirmationService', 'SSKeyHandoverService'];
app.controller('PropertyKeyHandoverController', PropertyKeyHandoverController);

// WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js (services.js is
// loaded on every page). A copy here would link it a second time on every element.

// app.directive('dateformat', function (dateFilter) {
//     return {
//         require:'ngModel',
//         link:function (scope, elm, attrs, ctrl) {

//             var dateFormat = attrs['date'] || 'dd/MM/yyyy';

//             ctrl.$formatters.unshift(function (modelValue) {
//                 return dateFilter(modelValue, dateFormat);
//             });
//         }
//     };
// })
